import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDivision(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M13 14V1.5a.5.5 0 0 0-.5-.5H3.504a.5.5 0 0 0-.5.5C3.004 2.045 3 2 3 2v12s.003-.3.003.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5c0-.871-.003-.5-.003-.5M4 2h8v12h-2v-2.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14H4zm5 12H7v-2h2zM5.5 4a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5m-3 2.5A.5.5 0 0 1 6 6h1a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5m3 0A.5.5 0 0 1 9 6h1a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M5.5 9a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5"
      />
    </SVGIcon>
  );
}
